module.exports = __webpack_public_path__ + "static/media/3.193403f2.jpg";